<template>
  <div v-if="liveSalesVisible && active && !isLoggedIn" id="ls-container">
      <a class="close-btn" href="javascript:" @click="closeWindow">
        <i class="fa fa-times"></i>
      </a>
      <div id="popup-close"></div>
      <NuxtLink :to="getActivityLink(liveStatsData?.type, liveStatsData?.product?.name)" id="ls-link">
          <div class="ls-image-container">
              <ResponsiveImage :mediaId="currentMediaId" />
          </div>
          <div class="ls-desc">
            <p id="ls-action">
                A smart person from {{ liveStatsData?.country }} {{ getActivityAction(liveStatsData?.type) }} {{ liveStatsData?.product?.name }}
            </p>

              <p id="ls-time">{{ liveStatsData?.time }}</p>
          </div>
      </NuxtLink>
      <div class="triangle"></div>
  </div>
</template>

  
<script setup>
import { ref, onBeforeMount, onBeforeUnmount, watchEffect, computed, onMounted } from 'vue';
import { useUIStore } from '~/store/uiStore';
import { useUserStore } from '~/store/userStore';
import { useDataStore } from '~/store/dataStore';
import { ActivityType } from '~/api/apiClient';
import APIClient from '~/api/apiClient';
  
const apiClient = APIClient.getInstance();

// Real-time data
const liveStatsData = ref(null);
const link = ref('/shop');

const fetchLiveStats = async () => {
  try {
    const response = await apiClient.getLiveStats(12);  
    liveStatsData.value = response.result;
    console.log("Live stats:", liveStatsData.value);
    setMediaIdFromLiveStats(); // set the current product from live stats data
  } catch (error) {
    console.error("Error fetching live stats:", error);
  }
};

const uiStore = useUIStore();
const userStore = useUserStore();
const dataStore = useDataStore();
const isLoggedIn =  computed(() => userStore.userData?.is_logged_in || false);

const bundles = computed(() => dataStore.products?.bundle);
const pluginData = computed(() => dataStore.products.plugin);
const samplepackData = computed(() => dataStore.products.samplepack);

const liveSalesVisible = ref(false);
const active = ref(true);
let timerVar = null;

const getActivityAction = (type) => {
  switch (type) {
    case ActivityType.Download:
      return "has downloaded";
    case ActivityType.Registration:
      return "has registered for an account";
    case ActivityType.Review:
      return "has reviewed";
    case ActivityType.Shop:
      return "has bought";
    default:
      return "";
  }
};

const getActivityLink = (type, product) => {
  switch (type) {
    case ActivityType.Download:
      return dataStore.getProductSlug(product);
    case ActivityType.Review:
      return dataStore.getProductSlug(product);
    case ActivityType.Registration:
      return '/account';
    case ActivityType.Shop:
      return '/shop';
    default:
      return "";
  }
};

const currentMediaId = ref(0);

const setMediaIdFromLiveStats = () => {
  currentMediaId.value = 0;
  if (liveStatsData.value.type === ActivityType.Registration)
  {    
    currentMediaId.value = 164954;
    return;
  } 

  if (!liveStatsData.value?.product?.name) return;

  const productName = liveStatsData.value.product.name;
  const foundIndex = allProducts.value.findIndex(product => product.name === productName);
  
  if (foundIndex !== -1) {
    currentMediaId.value = allProducts.value[foundIndex].showcaseId;
  } else {
    console.warn(`Product named '${productName}' not found in available products.`);
  }
};

const nextCycle = async () => {
  liveSalesVisible.value = !liveSalesVisible.value;
  if(!liveSalesVisible.value)
    await fetchLiveStats();
  timerVar = setTimeout(nextCycle, getRandomNumber(10000, 35000));
};

const closeWindow = () => {
  active.value = false;
  sessionStorage.setItem('liveSalesClosed', 'true');
};

const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

const allProducts = computed(() => [...pluginData.value, ...samplepackData.value, ...bundles.value]);

onBeforeMount(() => {
  timerVar = setTimeout(nextCycle, 15000);
});

onMounted(() => {
  dataStore.fetchProductData().then(() => {
    fetchLiveStats();
  });
  if (sessionStorage.getItem('liveSalesClosed')) {
    active.value = false;
  }
});

onBeforeUnmount(() => {
  clearTimeout(timerVar);
});

watchEffect(() => {
  liveSalesVisible.value = uiStore.liveSales;
});
</script>


<style lang="scss" scoped>
@import '~/assets/constants.scss';
.ls-image-container
{
    width: 15vw;
}

#ls-container {
    border-radius: $fa-border-radius;
    display: inline-grid;
    position: fixed;
    bottom: 1em;
    left: 1em;
    background: rgba(0,0,0,0.75);
    padding: 0.5em;
    height: auto;
    z-index: 990;
    max-width: 45%;
}

#ls-link {
    display: flex;
}

.ls-desc {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 1rem;
}

#ls-image {
    width: 15vw;
}

#ls-action {
    font-size: 1.0rem; 
    color: #fff;
    word-wrap: break-word; /* Allows the text to break and wrap onto the next line */
    white-space: normal; /* Ensures whitespace is handled like in a standard block container */
}

#ls-time {
    font-size: 0.75rem; 
    color: #fff;
}

.ls-desc, #ls-action {
    max-width: 100%; /* Adjust based on your layout needs */
}

@media (max-width: 481px) {
  #ls-container {
    display: none;
  }
}

/* Triangle at the bottom of ls-container */
.triangle {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid rgba(0,0,0,0.75);
    position: absolute;
    bottom: -10px;
    left: calc(50% - 10px);  /* Center the triangle */
}
</style>
